import React from 'react';
import { Table, Row, Col } from 'antd';
import CSpin from 'apps/assets/components/CSpin';
import CCard from 'apps/assets/components/CCard';
import CButton from 'apps/assets/components/CButton';
import { TextInputSearch } from 'components/InputField';
import { DropdownBasic } from 'components/DropdownBasic';

export default function RoleComponent(props: any) {
  const { columns, handlePageAddNewLevel, isLoading } = props;
  const buttonData = [
    {
      type: 'link',
      className: 'btnLinkAdd',
      onClick: handlePageAddNewLevel,
      isLoading: false,
      content: <b>TAMBAH ROLE</b>,
      id: 'btnPopupAddComplaint',
    },
    {
      type: 'circle',
      className: 'btnTableAdd',
      onClick: handlePageAddNewLevel,
      isLoading: false,
      icon: 'plus',
      id: 'btnPopupAddComplaint',
    },
  ];
  const dataN = [
    {
      label: 'Aktif',
      key: 'Active',
    },
    {
      label: 'Tidak aktif',
      key: 'Disable',
    },
    {
      label: 'Semua',
      key: 'None',
    },
  ];

  return (
    <CSpin
      spinning={isLoading}
      size={'large'}
      content={
        <div className="defaultSpace">
          <CCard
            cardContent={
              <React.Fragment>
                <Row>
                  <Col span={10}>
                    <TextInputSearch
                      name="searchValue"
                      idComponent="inputSearch"
                      label="ROLE AKSES"
                      className="searchForm"
                      placeholder={'Cari berdasarkan nama atau tipe'}
                      regex={'noSpaceInFirstChar'}
                      value={props.searchGroup}
                      onChange={props.handleSearchGroup}
                      additionalHandleEnterFunc={() =>
                        props.handleSearchLevel(props.searchGroup)
                      }
                    />
                  </Col>
                  <Col span={6}>
                    <DropdownBasic
                      name="filterValue"
                      idComponent="filterValue"
                      dropdownMenu={dataN}
                      triggerAction={'click'}
                      labelTitle={'Aktif'}
                      className="floatLeft"
                      value={props.statusGroup}
                      onChange={props.handleStatusGroup}
                    />
                  </Col>
                  <Col span={8}>
                    <div className="floatRight">
                      <CButton buttonData={buttonData} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            }
          />
          <Table
            pagination={{
              onChange: page => {
                props.handlePage(page);
              },
              pageSize: 10,
              total: props.totalPagination,
              current: props.pagePagination === 0 ? 1 : props.pagePagination,
            }}
            bordered={false}
            dataSource={props.roles}
            columns={columns}
          />
        </div>
      }
    />
  );
}
